console.log('[bdz] swatch-drawer.js loaded');

(function () {
  const drawer = document.getElementById('bdz-swatch-drawer');
  if (!drawer) {
    console.log('[bdz] swatch drawer: no drawer element found on this page');
    return;
  }

  const overlay   = drawer.querySelector('.bdz-swatch-drawer__overlay');
  const panel     = drawer.querySelector('.bdz-swatch-drawer__panel');
  const closeEls  = drawer.querySelectorAll('[data-bdz-swatch-drawer-close]');
  const toggleBar = drawer.querySelector('[data-bdz-swatch-toggle]');
  const imgSwatch = drawer.querySelector('[data-bdz-swatch-img="swatch"]');
  const imgProduct = drawer.querySelector('[data-bdz-swatch-img="product"]');
  const comboLabelEl = drawer.querySelector('[data-bdz-swatch-combo-label]');
  const captionEl = drawer.querySelector('[data-bdz-swatch-caption]');

  // In‑drawer controls container
  const controlsEl = drawer.querySelector('[data-bdz-swatch-controls]');

  // New generic swatch rows (used by PDP + simple integrations)
  // These usually sit on the same nodes as the older data-bdz-drawer-* attributes.
  const frameRowSwatchesEl =
    drawer.querySelector('[data-bdz-swatch-row-swatches="frame"]');
  const secondaryRowSwatchesEl =
    drawer.querySelector('[data-bdz-swatch-row-swatches="secondary"]');

  // Legacy / bundle row targets & labels (used by bundle hydration logic)
  const primaryRow =
    drawer.querySelector('[data-bdz-drawer-primary-row]') ||
    (frameRowSwatchesEl && frameRowSwatchesEl.closest('.bdz-swatch-drawer__row')) ||
    null;
  const primaryLabelEl = drawer.querySelector('[data-bdz-drawer-primary-label]') || null;
  const primaryTarget =
    drawer.querySelector('[data-bdz-drawer-primary-target]') ||
    frameRowSwatchesEl ||
    null;

  const secondaryRow =
    drawer.querySelector('[data-bdz-drawer-secondary-row]') ||
    (secondaryRowSwatchesEl && secondaryRowSwatchesEl.closest('.bdz-swatch-drawer__row')) ||
    null;
  const secondaryLabelEl =
    drawer.querySelector('[data-bdz-drawer-secondary-label]') || null;
  const secondaryTarget =
    drawer.querySelector('[data-bdz-drawer-secondary-target]') ||
    secondaryRowSwatchesEl ||
    null;

  // Unified row swatch containers used by populateControls()
  const frameRowEl = frameRowSwatchesEl || primaryTarget;
  const secondaryRowEl = secondaryRowSwatchesEl || secondaryTarget;

  // Remember where focus was before we opened, so we can send it back.
  let previouslyFocused = null;

  // ---------------------------------------------------------------------------
  // Dual‑colour combo map
  // ---------------------------------------------------------------------------

  function normaliseValue(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  function isTopMaterialLabel(label) {
    return normaliseValue(label) === 'top material';
  }

  function buildComboMap() {
    const script = document.querySelector('script[id^="bdz-dual-combos"]');
    if (!script) {
      console.log('[bdz] swatch drawer: no dual-combo <script> found');
      return {};
    }

    try {
      const raw = JSON.parse(script.textContent || '{}');
      const entries = Array.isArray(raw.entries) ? raw.entries : [];
      const map = {};

      entries.forEach((entry) => {
        const frame  = normaliseValue(entry.frame);
        const fabric = normaliseValue(entry.fabric);
        if (!frame || !fabric) return;

        const key = `${frame}||${fabric}`;

        map[key] = {
          frame: entry.frame,
          fabric: entry.fabric,
          combinedSwatch: entry.combined_swatch,
          productImage: entry.product_image,
          swatchTitle: entry.swatch_title || '',
          label: entry.label || '',
          caption: entry.caption || ''
        };
      });

      console.log('[bdz] swatch drawer: dual-combo map', map);
      return map;
    } catch (err) {
      console.warn('[bdz] swatch drawer: failed to parse dual combo JSON', err);
      return {};
    }
  }

  const comboMap = buildComboMap();

  function findCombo(frameLabel, fabricLabel) {
    const key = `${normaliseValue(frameLabel)}||${normaliseValue(fabricLabel)}`;
    return comboMap[key] || null;
  }
// ---------------------------------------------------------------------------
// Single‑colour swatch map (per‑product metaobjects)
// ---------------------------------------------------------------------------

// Build a map from an array of metaobject-style entries
function buildSingleColourMapFromEntries(entries) {
  const map = {};
  (entries || []).forEach((entry) => {
    if (!entry) return;
    const rawValue = entry.colour_option_value || entry.value;
    const key = normaliseValue(rawValue);
    if (!key) return;

    map[key] = {
      value: rawValue,
      image: entry.large_swatch_image || entry.image || '',
      caption: entry.caption || ''
    };
  });
  return map;
}

// Initial map from the PDP-level <script id="bdz-single-colours-…">
function buildSingleColourMapFromScript() {
  const script = document.querySelector('script[id^="bdz-single-colours"]');
  if (!script) {
    // No single-colour data on this page – that's fine.
    return {};
  }

  try {
    const raw = JSON.parse(script.textContent || '{}');
    const entries = Array.isArray(raw.entries) ? raw.entries : [];
    const map = buildSingleColourMapFromEntries(entries);
    console.log('[bdz] swatch drawer: single‑colour map', map);
    return map;
  } catch (err) {
    console.warn(
      '[bdz] swatch drawer: failed to parse single‑colour swatch JSON',
      err
    );
    return {};
  }
}

const defaultSingleColourMap = buildSingleColourMapFromScript();
let singleColourMap = defaultSingleColourMap;

// Called per-open: use bundle line data if present, otherwise fall back
function useSingleColours(entries) {
  if (Array.isArray(entries) && entries.length) {
    singleColourMap = buildSingleColourMapFromEntries(entries);
  } else {
    singleColourMap = defaultSingleColourMap;
  }
}

  function findSingleColour(valueLabel) {
    const key = normaliseValue(valueLabel);
    return singleColourMap[key] || null;
  }

  // Helper: extract `url("...")` from a chip's background-image
  function getChipBgUrl(el) {
    if (!el || typeof window.getComputedStyle !== 'function') return '';

    try {
      const bg = window.getComputedStyle(el).backgroundImage || '';
      const match = bg && bg.match(/url\(["']?(.*?)["']?\)/i);
      return match && match[1] ? match[1] : '';
    } catch (err) {
      console.warn('[bdz] swatch drawer: unable to read chip background', err);
      return '';
    }
  }



  // ---------------------------------------------------------------------------
  // View toggle (Colour Swatch / Product Image)
  // ---------------------------------------------------------------------------

  let currentFrameLabel = '';
  let currentFabricLabel = '';
  let fallbackSwatchSrc = '';
  let fallbackProductSrc = '';
  let fallbackCaption = '';
  let currentView = 'swatch';
  let disableOverride = false;
  let currentSecondaryIsTopMaterial = false;

  function getSelectedTopMaterialLabel() {
    if (!secondaryTarget) return '';

    const selected =
      secondaryTarget.querySelector(
        '.bdz-swatch--top-material[aria-checked="true"]'
      ) ||
      secondaryTarget.querySelector(
        '[data-option-name="top-material"][aria-checked="true"]'
      );

    if (!selected) return '';

    return (
      selected.getAttribute('aria-label') ||
      selected.dataset.secondaryValue ||
      ''
    ).trim();
  }

  function setView(view) {
    // Normalise
    currentView = view === 'product' ? 'product' : 'swatch';

    // Toggle bar buttons
    if (toggleBar) {
      const buttons = toggleBar.querySelectorAll('[data-bdz-swatch-view]');
      buttons.forEach((btn) => {
        const isActive = btn.dataset.bdzSwatchView === currentView;

        // visual hook for CSS
        btn.classList.toggle('is-active', isActive);

        // accessibility + also used by CSS
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        btn.setAttribute('aria-current', isActive ? 'page' : 'false');
      });
    }

    // Make sure the right big image is visible
    if (imgSwatch) {
      imgSwatch.hidden = currentView !== 'swatch';
    }
    if (imgProduct) {
      imgProduct.hidden = currentView !== 'product';
    }

    // Keep caption visibility in sync with the current view
    if (captionEl) {
      const captionText = captionEl.textContent || '';
      const shouldShowCaption = !!captionText && currentView === 'product';
      captionEl.hidden = !shouldShowCaption;
    }
  }


  // ---------------------------------------------------------------------------
  // Preview image + labels
  // ---------------------------------------------------------------------------

  // Update the big swatch / product image + label + caption inside the drawer.
  // frameOverride / fabricOverride are optional – if you pass a string, we
  // overwrite the remembered label; if you pass null, we keep the old one.
  function refreshPreview(frameOverride, fabricOverride) {
    if (typeof frameOverride === 'string') {
      currentFrameLabel = frameOverride;
    }
    if (typeof fabricOverride === 'string') {
      currentFabricLabel = fabricOverride;
    }

    // Try dual-colour combo first (bundle use-case)
    let combo = null;
    if (currentFrameLabel && currentFabricLabel) {
      combo = findCombo(currentFrameLabel, currentFabricLabel);
    }

    // Then try single-colour metaobject (PDP use-case)
    let single = null;
    if (currentFrameLabel && typeof findSingleColour === 'function') {
      single = findSingleColour(currentFrameLabel);
    }

    const swatchSrc =
      (combo && combo.combinedSwatch) ||
      (single && single.image) ||
      fallbackSwatchSrc ||
      '';

    const productSrc =
      (!disableOverride && combo && combo.productImage)
        ? combo.productImage
        : (fallbackProductSrc || '');

    const captionText =
      (combo && combo.caption) ||
      (single && single.caption) ||
      fallbackCaption ||
      '';

    const topMaterialLabelText = currentFrameLabel && currentFabricLabel
      ? currentFrameLabel + ' & ' + currentFabricLabel
      : (currentFrameLabel || currentFabricLabel || '');

    // Display priority: Top Material uses selected values, then explicit combo
    // swatch title, single-colour caption, constructed string, then raw label.
    const comboLabelText =
      (currentSecondaryIsTopMaterial && topMaterialLabelText) ||
      (combo && combo.swatchTitle) ||
      (single && single.caption) ||
      (currentFrameLabel && currentFabricLabel
        ? currentFrameLabel + ' / ' + currentFabricLabel
        : (currentFrameLabel || ''));


    // --- Big swatch image ---
    if (imgSwatch) {
      if (swatchSrc) {
        imgSwatch.src = swatchSrc;
        imgSwatch.hidden = currentView !== 'swatch';
      } else {
        imgSwatch.src = '';
        imgSwatch.hidden = true;
      }
    }

    // --- Big product image ---
    if (imgProduct) {
      if (productSrc) {
        imgProduct.src = productSrc;
        imgProduct.hidden = currentView !== 'product';
      } else {
        imgProduct.src = '';
        imgProduct.hidden = true;
      }
    }

    // --- Combo label ---
    if (comboLabelEl) {
      comboLabelEl.textContent = comboLabelText;
      comboLabelEl.hidden = !comboLabelText;
    }

    // --- Caption (disclaimer) ---
    if (captionEl) {
      captionEl.textContent = captionText;
      const shouldShowCaption = !!captionText && currentView === 'product';
      captionEl.hidden = !shouldShowCaption;
    }

    // If the current view has no image any more, fall back to the other one.
    if (currentView === 'swatch' && !swatchSrc && productSrc) {
      setView('product');
    } else if (currentView === 'product' && !productSrc && swatchSrc) {
      setView('swatch');
    }
        // Remember what we're currently showing as the new fallback
    if (swatchSrc) {
      fallbackSwatchSrc = swatchSrc;
    }
    if (productSrc) {
      fallbackProductSrc = productSrc;
    }
    if (captionText) {
      fallbackCaption = captionText;
    }

  }

  // ---------------------------------------------------------------------------
  // In‑drawer swatch controls (generic helper)
  // ---------------------------------------------------------------------------

  function clearRow(rowEl) {
    if (!rowEl) return;
    while (rowEl.firstChild) {
      rowEl.removeChild(rowEl.firstChild);
    }
  }

  // Options this will expect:
  //   frameButtons: NodeList/array of real clickable swatch buttons/labels
  //   secondary: {
  //     label: 'Some label',
  //     values: [{ value, label, style }],
  //     selected: 'Value',
  //     onSelect: (value) => { /* sync external UI */ }
  //   }
  //   getSecondaryConfig: () => secondaryConfig   // PDP helper (optional)
  function populateControls(opts) {
    if (!controlsEl) return;

    const options = opts || {};
    const getSecondaryConfig =
      typeof options.getSecondaryConfig === 'function'
        ? options.getSecondaryConfig
        : null;

    // ─────────────────────────────────────────────
    // Secondary row helper (fabric / cushions)
    // ─────────────────────────────────────────────
    const secRowEl = secondaryRowEl;
    const secWrapper = secRowEl
      ? secRowEl.closest('.bdz-swatch-drawer__row')
      : null;

    function renderSecondaryRow(secondary) {
      clearRow(secRowEl);
      if (secWrapper) {
        secWrapper.classList.remove('bdz-swatch-drawer__row--top-material');
      }
      if (secRowEl) {
        secRowEl.classList.remove('bdz-swatch-drawer__row-swatches--top-material');
        delete secRowEl.dataset.bdzSwatchOptionLabel;
      }
      currentSecondaryIsTopMaterial = false;

      if (
        secRowEl &&
        secondary &&
        Array.isArray(secondary.values) &&
        secondary.values.length
      ) {
        if (secWrapper) secWrapper.hidden = false;

        const secondaryLabel = (secondary.label || '').trim();
        const isTopMaterial = isTopMaterialLabel(secondaryLabel);
        currentSecondaryIsTopMaterial = isTopMaterial;

        if (secWrapper) {
          secWrapper.classList.toggle(
            'bdz-swatch-drawer__row--top-material',
            isTopMaterial
          );
        }
        if (secRowEl) {
          secRowEl.classList.toggle(
            'bdz-swatch-drawer__row-swatches--top-material',
            isTopMaterial
          );
          secRowEl.dataset.bdzSwatchOptionLabel = secondaryLabel;
        }

        if (secondaryLabelEl) {
          secondaryLabelEl.textContent = secondaryLabel;
        }

        secondary.values.forEach((entry) => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = isTopMaterial
            ? 'bdz-swatch bdz-swatch--top-material'
            : 'bdz-swatch';
          btn.setAttribute('role', 'radio');
          btn.setAttribute(
            'aria-label',
            entry.label || entry.value
          );
          if (isTopMaterial) {
            btn.dataset.optionName = 'top-material';
          }
          btn.setAttribute(
            'aria-checked',
            entry.value === secondary.selected ? 'true' : 'false'
          );

          const chip = document.createElement('span');
          chip.className = 'bdz-swatch__chip';
          if (entry.style) {
            chip.style.cssText = entry.style;
          }
          btn.appendChild(chip);

          btn.addEventListener('click', () => {
            if (typeof secondary.onSelect === 'function') {
              // This will click the real PDP swatch (or bundle control)
              // so the actual variant selection updates.
              secondary.onSelect(entry.value);
            }

            // Update the visual selection inside the drawer
            Array.from(
              secRowEl.querySelectorAll('.bdz-swatch[role="radio"]')
            ).forEach((other) => {
              other.setAttribute(
                'aria-checked',
                other === btn ? 'true' : 'false'
              );
            });

            // After the variant change has settled, resolve the
            // *current* variant image and refresh the preview.
            window.setTimeout(() => {
              let productSrc = '';

              try {
                const variantScript = document.querySelector(
                  'variant-options script[type="application/json"]'
                );

                if (variantScript) {
                  const variants =
                    JSON.parse(variantScript.textContent || '[]') || [];

                  const idInput = document.querySelector(
                    'form[action*="/cart/add"] [name="id"]'
                  );

                  if (idInput) {
                    const currentId = parseInt(idInput.value, 10);
                    if (currentId) {
                      const match = variants.find(
                        (v) => Number(v.id) === currentId
                      );
                      if (match) {
                        if (match.featured_image && match.featured_image.src) {
                          productSrc = match.featured_image.src;
                        } else if (
                          match.image &&
                          typeof match.image === 'string'
                        ) {
                          productSrc = match.image;
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                console.warn(
                  '[bdz] swatch drawer (PDP): unable to resolve variant image from JSON for secondary',
                  err
                );
              }

              // Fallback: use the currently active hero image
              if (!productSrc) {
                const heroImg =
                  document.querySelector('[data-media-id].is-active img') ||
                  document.querySelector('.product__media img');

                if (heroImg) {
                  productSrc = heroImg.currentSrc || heroImg.src || '';
                }
              }

              // Update the fallback used by refreshPreview()
              if (productSrc) {
                fallbackProductSrc = productSrc;
              }

              if (typeof refreshPreview === 'function') {
                // Only fabric changed
                refreshPreview(null, entry.label || entry.value);
              }
            }, 150);
          });


          secRowEl.appendChild(btn);
        });
      } else if (secWrapper) {
        secWrapper.hidden = true;
      }
    }

    // ─────────────────────────────────────────────
    // Frame row (primary colour)
    // ─────────────────────────────────────────────
    const rowEl = frameRowEl;
    const frameWrapper = rowEl
      ? rowEl.closest('.bdz-swatch-drawer__row')
      : null;

    clearRow(rowEl);

    // Normalise frameButtons → array
    let sourceButtons = options.frameButtons || [];
    if (sourceButtons && !Array.isArray(sourceButtons)) {
      sourceButtons = Array.from(sourceButtons);
    }

    if (rowEl && sourceButtons && sourceButtons.length) {
      if (frameWrapper) frameWrapper.hidden = false;

      // Build uniform .bdz-swatch buttons for the drawer,
      // using the PDP’s real swatches as “data sources”.
      const swatches = [];

      sourceButtons.forEach((srcBtn) => {
        if (!srcBtn) return;

        const swatch = {
          source: srcBtn,
          label: '',
          style: '',
          selected: false
        };

        // Label – prefer an explicit colour value (used for combo lookup),
// then fall back to aria-label / text.
swatch.label =
  srcBtn.getAttribute('data-colour-value') ||
  srcBtn.getAttribute('data-swatch-value') ||
  srcBtn.getAttribute('aria-label') ||
  (srcBtn.textContent || '').trim();

          // Style – read inline style from an inner chip element
          // Prefer .bdz-swatch__chip (bundle Colour Preset buttons),
          // then fall back to Wonder's .f-swatch__list__link__content,
          // then the button itself.
          const content =
            srcBtn.querySelector('.bdz-swatch__chip') ||
            srcBtn.querySelector('.f-swatch__list__link__content') ||
            srcBtn;

        if (content) {
          const inline = content.getAttribute('style');
          if (inline && inline.trim()) {
            swatch.style = inline;
          } else if (typeof window.getComputedStyle === 'function') {
            const cs = window.getComputedStyle(content);
            const parts = [];
            const bgImage = cs.backgroundImage;
            const bgColor = cs.backgroundColor;
            const bgSize = cs.backgroundSize;
            const bgPos = cs.backgroundPosition;

            if (bgImage && bgImage !== 'none') {
              parts.push('background-image:' + bgImage + ';');
            }
            if (
              bgColor &&
              bgColor !== 'rgba(0, 0, 0, 0)' &&
              bgColor !== 'transparent'
            ) {
              parts.push('background-color:' + bgColor + ';');
            }
            if (bgSize && bgSize !== 'auto') {
              parts.push('background-size:' + bgSize + ';');
            }
            if (bgPos && bgPos !== '0% 0%') {
              parts.push('background-position:' + bgPos + ';');
            }

            swatch.style = parts.join(' ');
          }
        }

        // Selected state
        swatch.selected =
          srcBtn.classList.contains('is-selected') ||
          srcBtn.classList.contains('active') ||
          srcBtn.getAttribute('aria-checked') === 'true' ||
          false;

        swatches.push(swatch);
      });

      swatches.forEach((swatch) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bdz-swatch';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-label', swatch.label || '');
        btn.setAttribute(
          'aria-checked',
          swatch.selected ? 'true' : 'false'
        );

        const chip = document.createElement('span');
        chip.className = 'bdz-swatch__chip';
        if (swatch.style) {
          chip.style.cssText = swatch.style;
        }
        btn.appendChild(chip);

        btn.addEventListener('click', () => {
          // Update fallback swatch to this chip's background so
          // non‑combo colours still swap the big swatch correctly.
          const chipEl = btn.querySelector('.bdz-swatch__chip');
          const newSwatch = getChipBgUrl(chipEl);
          if (newSwatch) {
            fallbackSwatchSrc = newSwatch;
          }

          // 1) Proxy click to the real PDP/bundle swatch
          if (swatch.source && typeof swatch.source.click === 'function') {
            swatch.source.click();
          }

          // 2) Update the visual selection inside the drawer
          Array.from(
            rowEl.querySelectorAll('.bdz-swatch[role="radio"]')
          ).forEach((other) => {
            const isActive = other === btn;
            other.setAttribute('aria-checked', isActive ? 'true' : 'false');
          });

          // 3) After PDP scripts react, recompute label + product image
          window.setTimeout(() => {
            // 3a) Resolve the current frame label from the active colour radio
            let frameLabel = swatch.label || '';

            try {
              const fieldset =
                swatch.source && swatch.source.closest('fieldset');

              if (fieldset) {
                const activeInput = fieldset.querySelector(
                  'input[type="radio"]:checked'
                );

                if (activeInput) {
                  frameLabel =
                    activeInput.value ||
                    activeInput.getAttribute('aria-label') ||
                    frameLabel;
                }
              }
            } catch (err) {
              console.warn(
                '[bdz] swatch drawer (PDP): unable to resolve frame label',
                err
              );
            }

            // 3b) Work out the product image for the *current* variant
let productSrc = '';

// If this button came from a bundle Colour Preset, its source
// button will carry a preset hero image we can use directly.
if (swatch.source) {
  const presetHero =
    swatch.source.getAttribute('data-preset-image') || '';
  if (presetHero) {
    productSrc = presetHero;
  }
}

// If there was no preset hero, fall back to the current PDP variant.
if (!productSrc) {
  try {
    const variantScript = document.querySelector(
      'variant-options script[type="application/json"]'
    );

    if (variantScript) {
      const variants =
        JSON.parse(variantScript.textContent || '[]') || [];

      const idInput = document.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );

      if (idInput) {
        const currentId = parseInt(idInput.value, 10);
        if (currentId) {
          const match = variants.find(
            (v) => Number(v.id) === currentId
          );
          if (match) {
            if (match.featured_image && match.featured_image.src) {
              productSrc = match.featured_image.src;
            } else if (
              match.image &&
              typeof match.image === 'string'
            ) {
              productSrc = match.image;
            }
          }
        }
      }
    }
  } catch (err) {
    console.warn(
      '[bdz] swatch drawer (PDP): unable to resolve variant image from JSON',
      err
    );
  }
}


            // Fallback: read the currently active hero image from the DOM
            if (!productSrc) {
              const heroImg =
                document.querySelector('[data-media-id].is-active img') ||
                document.querySelector('.product__media img');

              if (heroImg) {
                productSrc = heroImg.currentSrc || heroImg.src || '';
              }
            }

              // 3c) Rebuild the secondary (cushion) row to match this frame
              let fabricOverride = null;
              if (typeof getSecondaryConfig === 'function') {
                try {
                  const updatedSecondary = getSecondaryConfig(frameLabel);
                  options.secondary = updatedSecondary || null;
                  renderSecondaryRow(updatedSecondary || null);

                if (
                  updatedSecondary &&
                  Array.isArray(updatedSecondary.values) &&
                  updatedSecondary.values.length
                ) {
                  const selectedEntry =
                    updatedSecondary.values.find(
                      (v) => v.value === updatedSecondary.selected
                    ) || updatedSecondary.values[0];

                  if (selectedEntry) {
                    fabricOverride =
                      selectedEntry.label || selectedEntry.value || null;
                  }
                }
              } catch (err) {
                console.warn(
                  '[bdz] swatch drawer (PDP): unable to refresh secondary swatches for new frame',
                  err
                );
              }
            }

            if (productSrc) {
              // Update the fallback so refreshPreview() uses the new image
              fallbackProductSrc = productSrc;
            }

            if (typeof refreshPreview === 'function') {
              // Frame changed; fabric may also have changed if the variant
              // switched to a different cushion colour
              refreshPreview(frameLabel, fabricOverride);
            }
          }, 150);
        });

        rowEl.appendChild(btn);
      });
    } else if (frameWrapper) {
      frameWrapper.hidden = true;
    }

    // Initial secondary row render using whatever was passed in
    renderSecondaryRow(options.secondary || null);
  }

  // Build swatch buttons for a secondary dropdown (e.g. Sunbrella® Cushions)
  function buildSecondarySwatches(
    selectEl,
    stylesMap,
    rowEl,
    targetEl,
    labelEl,
    labelText,
    bundleSecondaryHook
  ) {
    if (!selectEl || !rowEl || !targetEl) return;

    // Clear any old buttons
    targetEl.innerHTML = '';

    const resolvedLabel =
      labelText ||
      selectEl.getAttribute('data-label') ||
      selectEl.getAttribute('aria-label') ||
      'Cushions';
    const isTopMaterial = isTopMaterialLabel(resolvedLabel);
    currentSecondaryIsTopMaterial = isTopMaterial;

    rowEl.classList.toggle('bdz-swatch-drawer__row--top-material', isTopMaterial);
    targetEl.classList.toggle(
      'bdz-swatch-drawer__row-swatches--top-material',
      isTopMaterial
    );
    targetEl.dataset.bdzSwatchOptionLabel = resolvedLabel;

    if (labelEl) {
      labelEl.textContent = resolvedLabel;
    }

    const options = Array.from(selectEl.options || []).filter((opt) => !opt.disabled);

    if (!options.length) {
      rowEl.hidden = true;
      return;
    }

    // For ARIA we treat this as a separate radiogroup
    targetEl.setAttribute('role', 'radiogroup');

    const currentValue = selectEl.value;

    options.forEach((opt) => {
      const value = opt.value;
      const label = opt.textContent.trim();
      if (!value) return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = isTopMaterial
        ? 'bdz-swatch bdz-swatch--top-material'
        : 'bdz-swatch';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-label', label);
      if (isTopMaterial) {
        btn.dataset.optionName = 'top-material';
      }
      btn.dataset.secondaryValue = value;

      const chip = document.createElement('span');
      chip.className = 'bdz-swatch__chip';

      // Look up by exact value/label – this matches the JSON keys
      const key = value || label;
      const style =
        stylesMap && Object.prototype.hasOwnProperty.call(stylesMap, key)
          ? stylesMap[key]
          : '';

      if (style) {
        chip.style.cssText = style;
      }

      btn.appendChild(chip);

      // Checked state
      btn.setAttribute('aria-checked', value === currentValue ? 'true' : 'false');

            btn.addEventListener('click', () => {
        // Update fallback swatch to this secondary chip so that
        // pure-fabric changes still move the Colour Swatch view
        // when there is no dual-colour combo metaobject.
        const chipEl = btn.querySelector('.bdz-swatch__chip');
        const newSwatch = getChipBgUrl(chipEl);
        if (newSwatch) {
          fallbackSwatchSrc = newSwatch;
        }

        // 1) Keep the underlying <select> in sync with the swatch
        if (selectEl.value !== value) {
          selectEl.value = value;
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // ...rest of the existing handler unchanged...


        // 2) Optional global hook so the drawer can drive the
        //    bundle-wide "Choose a Preseted Look" secondary control.
        if (typeof bundleSecondaryHook === 'function') {
          try {
            bundleSecondaryHook({ value, label });
          } catch (err) {
            console.warn(
              '[bdz] swatch drawer: secondary bundle hook failed',
              err
            );
          }
        }

        // 3) Update checked states in the drawer
        Array.from(
          targetEl.querySelectorAll('.bdz-swatch[role="radio"]')
        ).forEach((other) => {
          other.setAttribute('aria-checked', other === btn ? 'true' : 'false');
        });

        // 4) After the bundle / PDP JS has reacted, resolve the *current*
        //    fabric label and product image, then refresh the preview.
        window.setTimeout(() => {
          // 4a) Derive the current fabric label from the dropdown.
          //     (We re-read from the <select> so things like "– sold out"
          //     suffixes can be normalised.)
          let fabricLabel = label;
          if (selectEl && selectEl.options && selectEl.selectedIndex >= 0) {
            const opt = selectEl.options[selectEl.selectedIndex];
            if (opt) {
              fabricLabel = (opt.textContent || '').trim();
              // Strip trailing " – sold out" etc.
              fabricLabel = fabricLabel.replace(/\s+–.*$/, '').trim();
            }
          }

          // 4b) For bundle line-items, update fallbackProductSrc from the
          //     line-item thumbnail so non-combo cases still update.
          try {
            const itemRoot =
              selectEl.closest('.bdz-item') ||
              selectEl.closest('[data-bdz-item]') ||
              null;

            if (itemRoot) {
              const thumbImg =
                itemRoot.querySelector('.bdz-item__img img') ||
                itemRoot.querySelector('.bdz-item__img');

              if (thumbImg) {
                const newSrc = thumbImg.currentSrc || thumbImg.src || '';
                if (newSrc) {
                  fallbackProductSrc = newSrc;
                }
              }
            }
          } catch (err) {
            console.warn(
              '[bdz] swatch drawer: unable to read line-item image after secondary change',
              err
            );
          }

          // 4c) Refresh the big preview.
          //     - If a dual-colour combo exists for (frame, fabric),
          //       refreshPreview() will use combo.productImage.
          //     - Otherwise it falls back to the updated fallbackProductSrc.
          if (typeof refreshPreview === 'function') {
            // Frame stays the same; only fabric changed.
            refreshPreview(null, fabricLabel);
          }
        }, 150);
      });



      targetEl.appendChild(btn);
    });

    rowEl.hidden = false;
  }

  // ---------------------------------------------------------------------------
  // Open / close
  // ---------------------------------------------------------------------------

function open(options) {
  const opts = options || {};

  // NEW: pick the correct single-colour map for this open().
  // For bundle lines we pass opts.singleColours; otherwise we fall back
  // to the PDP-level script map.
  if (typeof useSingleColours === 'function') {
    useSingleColours(
      Array.isArray(opts.singleColours) ? opts.singleColours : null
    );
  }

  disableOverride = !!opts.disableOverride;
  currentSecondaryIsTopMaterial =
    isTopMaterialLabel(opts.secondaryLabel) ||
    isTopMaterialLabel(opts.secondary && opts.secondary.label);

  // Build the in-drawer swatch rows, if we were given data
    populateControls(opts);

    // Capture focus before we open
    previouslyFocused =
      document.activeElement instanceof HTMLElement
        ? document.activeElement
        : null;

    // 1) Look up a dual‑colour combo if we have frame + fabric labels
    let combo = null;
    if (opts.frame && opts.fabric) {
      combo = findCombo(opts.frame, opts.fabric);
    }

    const swatchSrc =
      (combo && combo.combinedSwatch) ||
      opts.swatchSrc ||
      '';

    const productSrc =
      (!disableOverride && combo && combo.productImage)
        ? combo.productImage
        : (opts.productSrc || '');

    const captionText =
      (combo && combo.caption) ||
      opts.caption ||
      '';

    // Remember the base state for refreshPreview()
    currentFrameLabel  = opts.frame || '';
    currentFabricLabel = opts.fabric || '';
    if (currentSecondaryIsTopMaterial && !currentFabricLabel) {
      currentFabricLabel = getSelectedTopMaterialLabel();
    }
    fallbackSwatchSrc  = swatchSrc;
    fallbackProductSrc = productSrc;
    fallbackCaption    = captionText;

    // Populate images + caption once for initial open
    refreshPreview(null, null);

    // -----------------------------------------------------------------------
    // Legacy bundle hydration logic
    //
    // For bundle contexts we clone the on‑page rails (primaryRail /
    // secondarySelect). For PDP we rely on populateControls() above, so if
    // neither of those is supplied we skip this block entirely.
    // -----------------------------------------------------------------------
    const hasFrameButtons =
      !!(opts.frameButtons && opts.frameButtons.length);

    if (opts.primaryRail || opts.secondarySelect) {
      // Clear any previous clones built from a previous open().
      // If frameButtons are supplied (bundle-global), the generic
      // populateControls() already rendered the primary row, so we
      // leave that alone and only reset the secondary row here.
      if (!hasFrameButtons && primaryTarget) primaryTarget.innerHTML = '';
      if (secondaryTarget) secondaryTarget.innerHTML = '';

      if (!hasFrameButtons && primaryRow) primaryRow.hidden = true;
      if (secondaryRow) secondaryRow.hidden = true;

      // 1) Primary / frame rail: clone the existing .bdz-swatches rail
      //    only when we are *not* using frameButtons.
      if (!hasFrameButtons && opts.primaryRail && primaryTarget) {
        const originalRail = opts.primaryRail;
        const clone = originalRail.cloneNode(true);

        // Remove nested “+ Colour detail” chips inside the clone
        Array.from(
          clone.querySelectorAll('[data-bdz-swatch-drawer-trigger]')
        ).forEach((el) => el.remove());

        primaryTarget.appendChild(clone);

        if (primaryLabelEl && opts.primaryLabel) {
          primaryLabelEl.textContent = opts.primaryLabel;
        }

        if (primaryRow) primaryRow.hidden = false;

        // When you click a cloned swatch inside the drawer...
  clone.addEventListener('click', (evt) => {
    const btn = evt.target.closest('.bdz-swatch[data-colour-value]');
    if (!btn) return;

    // Ensure fallback swatch follows the clicked frame chip
          const chipEl = btn.querySelector('.bdz-swatch__chip');
          const newSwatch = getChipBgUrl(chipEl);
          if (newSwatch) {
            fallbackSwatchSrc = newSwatch;
          }

    const frameLabel =
      btn.getAttribute('aria-label') || btn.dataset.colourValue || '';

    // 1) Try the explicit bundle hook first
    if (typeof opts.onBundleFrameChange === 'function') {
      try {
        opts.onBundleFrameChange({ label: frameLabel });
      } catch (err) {
        console.warn(
          '[bdz] swatch drawer: onBundleFrameChange hook failed',
          err
        );
      }
    } else {
      // 2) Fallback: find the matching swatch in the original rail
      const value = btn.dataset.colourValue;
      const origBtn =
        value &&
        originalRail.querySelector(
          `.bdz-swatch[data-colour-value="${CSS.escape(value)}"]`
        );

      if (origBtn && typeof origBtn.click === 'function') {
        origBtn.click();
      }
    }

    // 3) Update checked states inside the cloned rail
    Array.from(
      clone.querySelectorAll('.bdz-swatch[role="radio"]')
    ).forEach((other) => {
      other.setAttribute(
        'aria-checked',
        other === btn ? 'true' : 'false'
      );
    });

    // 4) After the bundle JS has reacted (variant + thumbnail + secondary
    //    dropdown updated), rebuild the secondary row, pull the current
    //    fabric label and thumbnail image, then refresh the preview.
    window.setTimeout(() => {
      // 4a) Rebuild the secondary swatches in case the dropdown options
      //     changed because of the frame change
      if (opts.secondarySelect && secondaryTarget && secondaryRow) {
        buildSecondarySwatches(
          opts.secondarySelect,
          opts.secondaryStyles || {},
          secondaryRow,
          secondaryTarget,
          secondaryLabelEl,
          opts.secondaryLabel,
          typeof opts.onBundleSecondaryChange === 'function'
            ? opts.onBundleSecondaryChange
            : null
        );
      }

      // 4b) Derive the current fabric label from the dropdown (if present)
      let fabricLabel = null;
      const selectEl = opts.secondarySelect;
      if (selectEl && selectEl.options && selectEl.selectedIndex >= 0) {
        const opt = selectEl.options[selectEl.selectedIndex];
        if (opt) {
          fabricLabel = (opt.textContent || '').trim();
          // Strip " – sold out" style suffixes
          fabricLabel = fabricLabel.replace(/\s+–.*$/, '').trim();
        }
      }

      // 4c) Update fallbackProductSrc from the line‑item thumbnail image
      try {
        const itemRoot =
          originalRail.closest('.bdz-item') ||
          originalRail.closest('[data-bdz-item]') ||
          null;

        if (itemRoot) {
          const thumbImg =
            itemRoot.querySelector('.bdz-item__img img') ||
            itemRoot.querySelector('.bdz-item__img');

          if (thumbImg) {
            const newSrc = thumbImg.currentSrc || thumbImg.src || '';
            if (newSrc) {
              fallbackProductSrc = newSrc;
            }
          }
        }
      } catch (err) {
        console.warn(
          '[bdz] swatch drawer: unable to read line-item image',
          err
        );
      }

      // 4d) Finally, refresh the big preview with the updated
      //     frame + fabric labels. refreshPreview() will either
      //     use a dual-colour combo image (if available) or
      //     fall back to the updated fallbackProductSrc.
      if (typeof refreshPreview === 'function') {
        refreshPreview(frameLabel, fabricLabel);
      }
    }, 150);
  });

      }

      // 2) Secondary / cushion rail: build from dropdown + styles
      if (opts.secondarySelect && secondaryTarget && secondaryRow) {
        buildSecondarySwatches(
          opts.secondarySelect,
          opts.secondaryStyles || {},
          secondaryRow,
          secondaryTarget,
          secondaryLabelEl,
          opts.secondaryLabel,
          typeof opts.onBundleSecondaryChange === 'function'
            ? opts.onBundleSecondaryChange
            : null
        );
      }

    }

    if (
      opts.context === 'bundle-global' &&
      opts.secondarySelect &&
      secondaryRow &&
      secondaryTarget &&
      frameRowEl
    ) {
      // Avoid stacking multiple listeners across opens
      if (frameRowEl.__bdzBundleGlobalListener) {
        frameRowEl.removeEventListener(
          'click',
          frameRowEl.__bdzBundleGlobalListener
        );
        delete frameRowEl.__bdzBundleGlobalListener;
      }

      const listener = (event) => {
        const btn = event.target.closest('.bdz-swatch[role="radio"]');
        if (!btn || !frameRowEl.contains(btn)) return;

        const chipEl = btn.querySelector('.bdz-swatch__chip');
        const newSwatch = getChipBgUrl(chipEl);
        if (newSwatch) {
          fallbackSwatchSrc = newSwatch;
        }

        const rawLabel =
          (btn.getAttribute('aria-label') ||
            btn.dataset.colourValue ||
            ''
          ).trim();
        if (!rawLabel) return;

        const frameLabel = rawLabel.replace(/\s+–.*$/, '').trim();

        // Let the existing per-button handler / preset logic run first,
        // then re-sync the drawer a moment later.
        window.setTimeout(() => {
          // 1) Rebuild the secondary (cushion) row from the updated dropdown
          buildSecondarySwatches(
            opts.secondarySelect,
            opts.secondaryStyles || {},
            secondaryRow,
            secondaryTarget,
            secondaryLabelEl,
            opts.secondaryLabel,
            typeof opts.onBundleSecondaryChange === 'function'
              ? opts.onBundleSecondaryChange
              : null
          );

          // 2) Work out the *current* cushion label
          let fabricLabel = '';
          const selectEl = opts.secondarySelect;
          if (selectEl && selectEl.options && selectEl.selectedIndex >= 0) {
            const selectedOpt = selectEl.options[selectEl.selectedIndex];
            if (selectedOpt) {
              fabricLabel = (selectedOpt.textContent || '').trim();
              // Strip trailing " – sold out" etc.
              fabricLabel = fabricLabel.replace(/\s+–.*$/, '').trim();
            }
          }

          // 3) Refresh the big preview: dual-combo (frame + cushion)
          if (typeof refreshPreview === 'function') {
            // pass both labels so findCombo(frame, fabric) can kick in
            refreshPreview(frameLabel, fabricLabel || null);
          }
        }, 150);
      };

      frameRowEl.addEventListener('click', listener);
      frameRowEl.__bdzBundleGlobalListener = listener;
    }

    // 3) Choose initial view
    const defaultView =
      swatchSrc ? 'swatch' :
      productSrc ? 'product' :
      'swatch';

    setView(defaultView);

    // 4) Actually open the drawer
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bdz-swatch-drawer-open');

    // Move focus into the drawer (close button preferred)
    const focusTarget =
      drawer.querySelector('.bdz-swatch-drawer__close') ||
      drawer.querySelector('.bdz-swatch-drawer__done');
    if (focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
  }

  function close() {
    // Restore focus *before* we hide with aria-hidden, to avoid the warning.
    if (previouslyFocused && document.contains(previouslyFocused)) {
      previouslyFocused.focus();
    } else if (document.body && typeof document.body.focus === 'function') {
      document.body.focus();
    }

    drawer.setAttribute('aria-hidden', 'true');
    drawer.hidden = true;
    document.documentElement.classList.remove('bdz-swatch-drawer-open');
  }

  // Overlay + “Done” / “×” buttons
  if (overlay) overlay.addEventListener('click', close);
  closeEls.forEach((btn) => btn.addEventListener('click', close));

  // Toggle “Colour Swatch” / “Product Image”
  if (toggleBar) {
    toggleBar.addEventListener('click', (evt) => {
      const btn = evt.target.closest('[data-bdz-swatch-view]');
      if (!btn) return;
      setView(btn.dataset.bdzSwatchView);
    });
  }

  // Optional: global event hook so other scripts can fire the drawer
  document.addEventListener('bdz:open-swatch-drawer', (event) => {
    open(event.detail || {});
  });

  // Small global API for debugging / wiring from other scripts
  window.bdzSwatchDrawer = {
    element: drawer,
    combos: comboMap,
    open,
    close
  };

// ---------------------------------------------------------------------------
// PDP “+ Colour detail” trigger (non‑bundle product pages)
// ---------------------------------------------------------------------------
function setupPdpSwatchDrawerTrigger() {
  const triggerSelector = '[data-bdz-swatch-drawer-trigger="pdp"]';

  // If there is no PDP trigger on this page, nothing to do.
  if (!document.querySelector(triggerSelector)) return;

  // Try to pull variants JSON from the <variant-options> script
  let variants = [];
  const variantScript = document.querySelector(
    'variant-options script[type="application/json"]'
  );

  if (variantScript) {
    try {
      variants = JSON.parse(variantScript.textContent || '[]') || [];
    } catch (err) {
      console.warn(
        '[bdz] swatch drawer (PDP): failed to parse variants JSON',
        err
      );
    }
  }

  function getCurrentVariant() {
    try {
      if (!variants.length) return null;

      const idInput = document.querySelector(
        'form[action*="/cart/add"] [name="id"]'
      );
      if (!idInput) return null;

      const currentId = parseInt(idInput.value, 10);
      if (!currentId) return null;

      for (let i = 0; i < variants.length; i += 1) {
        if (Number(variants[i].id) === currentId) {
          return variants[i];
        }
      }
    } catch (e) {
      console.warn(
        '[bdz] swatch drawer (PDP): unable to resolve current variant',
        e
      );
    }
    return null;
  }

  // Map "+ Colour detail" chips → their option fieldsets by position (1, 2, …)
  const triggerEls = Array.from(document.querySelectorAll(triggerSelector));
  const fieldsetsByPosition = new Map();

  triggerEls.forEach((btn) => {
    const pos = parseInt(
      btn.getAttribute('data-bdz-swatch-option-position') || '0',
      10
    );
    const fs = btn.closest('fieldset');
    if (!pos || !fs) return;
    if (!fieldsetsByPosition.has(pos)) {
      fieldsetsByPosition.set(pos, fs);
    }
  });

  function getFieldsetForPosition(pos) {
    return fieldsetsByPosition.get(pos) || null;
  }

// Build a "secondary" config object (used by populateControls) from a
// colour‑swatch fieldset on the PDP – mirrors the bundle payload shape.
// frameLabelOverride is optional; when provided we filter using that
// frame colour instead of trying to infer it from the current variant.
function buildSecondaryFromFieldset(fieldset, frameLabelOverride) {
  if (!fieldset) return null;

  const inputs = Array.from(
    fieldset.querySelectorAll('input[type="radio"]')
  );
  if (!inputs.length) return null;

  // Normalised list of all candidate secondary values on this fieldset
  const radioMeta = [];
  inputs.forEach((input) => {
    const rawValue = (input.value || '').toString();
    if (!rawValue) return;
    radioMeta.push({
      input,
      rawValue,
      normValue: normaliseValue(rawValue)
    });
  });
  if (!radioMeta.length) return null;

  // Row label – prefer the visible option title
  let labelText = '';
  const labelEl =
    fieldset.querySelector('.wt-product__option__title .label') ||
    fieldset.querySelector('legend .label') ||
    fieldset.querySelector('legend') ||
    fieldset.querySelector('.label');

  if (labelEl && labelEl.textContent) {
    labelText = labelEl.textContent.replace(':', '').trim();
  }

  // ─────────────────────────────────────────────
  // Limit secondary values to real variants
  // ─────────────────────────────────────────────

  // All secondary values that this fieldset can show
  const knownSecondary = new Set(
    radioMeta.map((m) => m.normValue).filter(Boolean)
  );

  let allowedSecondary = null; // null → no filtering

  if (
    knownSecondary.size &&
    Array.isArray(variants) &&
    variants.length
  ) {
    const getVariantOptions = (variant) => {
      if (!variant) return [];
      // Prefer an "options" array if present
      if (Array.isArray(variant.options) && variant.options.length) {
        return variant.options
          .map((v) => (v == null ? '' : v.toString()))
          .filter(Boolean);
      }
      // Fallback to option1 / option2 / option3
      const out = [];
      if (variant.option1) out.push(variant.option1);
      if (variant.option2) out.push(variant.option2);
      if (variant.option3) out.push(variant.option3);
      return out;
    };

    // 1) Prefer an explicit frame label passed in from the caller
    let frameNorm = normaliseValue(frameLabelOverride);

    // 2) Fallback: infer the frame from the current variant
    if (!frameNorm && typeof getCurrentVariant === 'function') {
      const currentVariant = getCurrentVariant();
      if (currentVariant) {
        const currentOpts = getVariantOptions(currentVariant)
          .map(normaliseValue)
          .filter(Boolean);

        // Pick an option that is *not* one of the known secondary values
        for (let i = 0; i < currentOpts.length; i += 1) {
          const candidate = currentOpts[i];
          if (!knownSecondary.has(candidate)) {
            frameNorm = candidate;
            break;
          }
        }

        // Absolute fallback: first option
        if (!frameNorm && currentOpts.length) {
          frameNorm = currentOpts[0];
        }
      }
    }

    if (frameNorm) {
      allowedSecondary = new Set();

      variants.forEach((variant) => {
        const opts = getVariantOptions(variant);
        if (!opts.length) return;

        const normOpts = opts.map(normaliseValue);

        // Only consider variants that share the current frame value
        const hasFrame = normOpts.some((v) => v === frameNorm);
        if (!hasFrame) return;

        // Among those variants, collect any values that belong to
        // the secondary fieldset (cushion colours)
        normOpts.forEach((vNorm) => {
          if (knownSecondary.has(vNorm)) {
            allowedSecondary.add(vNorm);
          }
        });
      });

      // If we didn't find anything, fall back to showing everything
      if (!allowedSecondary.size) {
        allowedSecondary = null;
      }
    }
  }

  const values = [];
  let selectedValue = '';

  radioMeta.forEach((meta) => {
    // If we have an allowed set and this value never appears with the
    // current frame, skip it.
    if (allowedSecondary && !allowedSecondary.has(meta.normValue)) {
      return;
    }

    const { input, rawValue } = meta;

    const item = input.closest('.f-swatch__list__item');
    if (!item) return;

    const btn =
      item.querySelector('.f-swatch__list__link') ||
      item.querySelector('button, a');
    if (!btn) return;

    const content =
      btn.querySelector('.f-swatch__list__link__content') || btn;

    let styleText = '';
    if (content) {
      const inline = content.getAttribute('style');
      if (inline && inline.trim()) {
        styleText = inline;
      } else if (typeof window.getComputedStyle === 'function') {
        const cs = window.getComputedStyle(content);
        const parts = [];
        const bgImage = cs.backgroundImage;
        const bgColor = cs.backgroundColor;
        const bgSize = cs.backgroundSize;
        const bgPos = cs.backgroundPosition;

        if (bgImage && bgImage !== 'none') {
          parts.push('background-image:' + bgImage + ';');
        }
        if (
          bgColor &&
          bgColor !== 'rgba(0, 0, 0, 0)' &&
          bgColor !== 'transparent'
        ) {
          parts.push('background-color:' + bgColor + ';');
        }
        if (bgSize && bgSize !== 'auto') {
          parts.push('background-size:' + bgSize + ';');
        }
        if (bgPos && bgPos !== '0% 0%') {
          parts.push('background-position:' + bgPos + ';');
        }

        styleText = parts.join(' ');
      }
    }

    const entry = {
      value: rawValue,
      label: rawValue,
      style: styleText
    };

    if (input.checked) {
      selectedValue = rawValue;
    }

    values.push(entry);
  });

  if (!values.length) return null;

  if (!labelText) {
    // Safe default if we can't read the option title
    labelText = 'Sunbrella\u00ae Cushions';
  }

  // Ensure the selected value is part of the filtered list
  // If the current PDP selection is no longer allowed for this frame,
  // we "force" it to the first valid option and mirror that back to
  // the PDP fieldset.
  let forcedSelection = false;
  if (
    !selectedValue ||
    !values.some((entry) => entry.value === selectedValue)
  ) {
    selectedValue = values[0].value;
    forcedSelection = true;
  }

  const secondaryConfig = {
    label: labelText,
    values,
    selected: selectedValue,
    onSelect(value) {
      if (!value) return;
      const target = inputs.find(
        (inp) => (inp.value || '').toString() === value
      );
      if (!target) return;

      const item = target.closest('.f-swatch__list__item');
      const realBtn =
        item &&
        (item.querySelector('.f-swatch__list__link') ||
          item.querySelector('button, a'));

      // Prefer clicking the visible PDP swatch button so all theme
      // variant logic and gallery wiring runs as normal.
      if (realBtn && typeof realBtn.click === 'function') {
        realBtn.click();
      } else if (typeof target.click === 'function') {
        target.click();
      } else {
        target.checked = true;
        target.dispatchEvent(new Event('change', { bubbles: true }));
        target.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  };

  // If we had to force a new selected value because the old one
  // was filtered out for the current frame, also push that selection
  // into the PDP fieldset so the page can’t remain on an invalid combo.
  if (forcedSelection && secondaryConfig.selected) {
    try {
      secondaryConfig.onSelect(secondaryConfig.selected);
    } catch (err) {
      console.warn(
        '[bdz] swatch drawer (PDP): unable to force valid secondary selection',
        err
      );
    }
  }

  return secondaryConfig;
}

  document.addEventListener('click', (event) => {
    const chip = event.target.closest(triggerSelector);
    if (!chip) return;

    // Make sure the drawer API is ready
    if (
      !window.bdzSwatchDrawer ||
      typeof window.bdzSwatchDrawer.open !== 'function'
    ) {
      return;
    }

    // Primary row = first colour‑swatch option on the PDP (usually Frame colour)
    const primaryFieldset =
      getFieldsetForPosition(1) || chip.closest('fieldset');
    if (!primaryFieldset) return;

    // Secondary row = second colour‑swatch option (e.g. Sunbrella® Cushions)
    const secondaryFieldset = getFieldsetForPosition(2) || null;

    const selectedInput = primaryFieldset.querySelector(
      'input[type="radio"]:checked'
    );
    if (!selectedInput) return;

    const swatchItem = selectedInput.closest('.f-swatch__list__item');
    if (!swatchItem) return;

    const swatchContent = swatchItem.querySelector(
      '.f-swatch__list__link__content, .seg-swatch__chip'
    );
    if (!swatchContent || typeof window.getComputedStyle !== 'function') {
      return;
    }

    const style = window.getComputedStyle(swatchContent);
    let bgImage = style.backgroundImage;
    const bgColor = style.backgroundColor;

    // seg-swatch__chip carries background-image on element.style (inline),
    // getComputedStyle picks this up but falls back to the chip's own
    // background-color (#e0e0e0) if no image is set. Also try the label's
    // inline style directly as a belt-and-braces fallback.
    if ((!bgImage || bgImage === 'none') && swatchContent.parentElement) {
      const labelStyle = window.getComputedStyle(swatchContent.parentElement);
      if (labelStyle.backgroundImage && labelStyle.backgroundImage !== 'none') {
        bgImage = labelStyle.backgroundImage;
      }
    }

    let swatchSrc = '';
    const colourLabel =
      selectedInput.value ||
      selectedInput.getAttribute('aria-label') ||
      '';

    if (bgImage && bgImage !== 'none') {
      // Extract URL from background-image: url("…") → …
      swatchSrc = bgImage.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
    } else if (
      bgColor &&
      bgColor !== 'rgba(0, 0, 0, 0)' &&
      bgColor !== 'transparent'
    ) {
      // Generate a solid-colour SVG as a fallback swatch image
      swatchSrc =
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(
          '<svg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600">' +
            '<rect width="800" height="600" fill="' +
            bgColor +
            '"/>' +
          '</svg>'
        );
    }

    const variant = getCurrentVariant();
    let productSrc = '';

    if (variant) {
      // Try Shopify’s standard structures
      if (variant.featured_image && variant.featured_image.src) {
        productSrc = variant.featured_image.src;
      } else if (variant.image && typeof variant.image === 'string') {
        productSrc = variant.image;
      }
    }

    // Fallback: whatever main product image is currently visible
    if (!productSrc) {
      const heroImg =
        document.querySelector('[data-media-id].is-active img') ||
        document.querySelector('.product__media img');
      if (heroImg) {
        productSrc = heroImg.currentSrc || heroImg.src || '';
      }
    }

    // Secondary config + initial fabric label (if the product has a second option)
const secondary = buildSecondaryFromFieldset(secondaryFieldset, colourLabel);
    let fabricLabel = '';
    if (secondary && Array.isArray(secondary.values) && secondary.values.length) {
      const selected =
        secondary.values.find((v) => v.value === secondary.selected) ||
        secondary.values[0];
      fabricLabel = (selected && (selected.label || selected.value)) || '';
    }

    const captionParts = [];
    if (colourLabel) captionParts.push(colourLabel);
    if (fabricLabel) captionParts.push(fabricLabel);
    const caption =
      captionParts.length > 0
        ? captionParts.join(' / ')
        : colourLabel || '';

    // Collect the real swatch buttons from the *primary* fieldset so the
    // drawer can mirror the PDP frame colour row.
    const frameButtons = Array.from(
      primaryFieldset.querySelectorAll('.f-swatch__list__link')
    );

    const getSecondaryConfig =
    secondaryFieldset && typeof buildSecondaryFromFieldset === 'function'
    ? (frameLabel) =>
        buildSecondaryFromFieldset(secondaryFieldset, frameLabel)
    : null;

    window.bdzSwatchDrawer.open({
      // These names line up with the bundle payload so dual‑colour
      // combo logic + preview behave consistently.
      frame: colourLabel,
      fabric: fabricLabel,
      swatchSrc,
      productSrc,
      caption,
      // In‑drawer rows:
      frameButtons,
      secondary,
      getSecondaryConfig
    });
  });
}

setupPdpSwatchDrawerTrigger();


  console.log('[bdz] swatch drawer initialised', window.bdzSwatchDrawer);
})();
